import { ConfigService } from 'app/config/config.service';

export const CESIUM_MAP_CANVAS_SELECTOR = '.cesium-widget canvas';

export class CesiumMap {
    private readonly _viewerElement: Element;
    private readonly _creditContainerElement: Element;
    private readonly _viewer: Cesium.Viewer;
    private _configService: ConfigService;

    constructor(configService: ConfigService) {
        this._configService = configService;

        const viewerElement = document.createElement('div');
        viewerElement.style.height = '100%';
        viewerElement.style.width = '100%';

        const creditContainer = document.createElement('div');
        creditContainer.setAttribute('id', 'credit-container');

        this._viewerElement = viewerElement;
        this._creditContainerElement = creditContainer;
        this._viewer = this._setupViewer(viewerElement, creditContainer);
    }

    private _setupViewer(viewerElement: Element, creditContainerElement: Element): Cesium.Viewer {
        Cesium.Ion.defaultAccessToken = ConfigService.cesiumIonApiKey;

        const viewer = new Cesium.Viewer(viewerElement, {
            animation: false,
            baseLayerPicker: false,
            fullscreenButton: false,
            geocoder: false,
            homeButton: false,
            sceneModePicker: false,
            navigationHelpButton: false,
            infoBox: false,
            selectionIndicator: false,
            sceneMode: Cesium.SceneMode.SCENE3D,
            creditContainer: creditContainerElement,
            useBrowserRecommendedResolution: true,
        });

        // We had this set to false before upgrading to Cesium 1.89. The issue seems to have been fixed at some point
        // and enabling this fixes an issue with billboards where a thin outline shows up on top of other billboards.
        // Before 1.89 upgrade:
        //   This is unfortunate. For now we have to disable the logarithmicDepthBuffer as it causes artifacts with
        //   polylines in Cesium 1.48 https://github.com/AnalyticalGraphicsInc/cesium/issues/6573
        viewer.scene.logarithmicDepthBuffer = true;

        // Debug options
        viewer.scene.debugShowFramesPerSecond = this._configService.debugShowFramesPerSecond;

        return viewer;
    }

    get viewer() {
        return this._viewer;
    }

    appendMap(mapElement: Element) {
        mapElement.appendChild(this._viewerElement);
    }

    appendCredits(creditElement: Element) {
        creditElement.appendChild(this._creditContainerElement);
    }
}
